import { useContext } from 'react';
import { FeatureFlagsContext } from '../components/Shared/FeatureFlags.jsx';

const useFeatureFlag = (flag) => {
  //console.log('useFeatureFlag hook called by component with flag:', flag);
  const featureFlags = useContext(FeatureFlagsContext) || {};
  //console.log(`Feature flag "${flag}" accessed, value:`, featureFlags[flag]);
  return featureFlags[flag];
};

export { useFeatureFlag };